import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { getApprove, getUserBydelete, getUserDetailsById } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { Button, Modal } from "react-bootstrap";

const Profile = ({ id }) => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.profileReducer);
  const [serviceData, setServiceData] = useState(null);
  const toast = useRef(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getUserManagement = async () => {
    setIsLoading(true);
    getUserDetailsById(id, token)
      .then((res) => {
        setIsLoading(false);
        if (res) {
          setServiceData(res?.data?.data?.[0]);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    async function getAllAPI() {
      await getUserManagement();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVoiceType = (arr) => {
    if (arr && arr.length !== 0) {
      let voice = arr?.map((e) => e.name_en);
      return voice?.toString();
    }
    return "-";
  };

  const getVoiceLanguages = (arr) => {
    if (arr && arr.length !== 0) {
      let voice = arr?.map((e) => e.name_en);
      return voice?.toString();
    }
    return "-";
  };

  const getSpecialties = (array) => {
    if (!Array.isArray(array)) {
      array = [];
    }
    if (array && array.length !== 0) {
      let speciality = array?.map((e) => e.name_en);
      return speciality?.toString();
    }
    return "-";
  };

  const getConnectivity = (array) => {
    if (array && array.length !== 0) {
      let connectivities = array?.map((e) => e.name_en);
      return connectivities?.toString();
    }
    return "-";
  };

  const deleteUser = async (id) => {
    setIsLoading(true);
    setShow(false);
    getUserBydelete(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate("/user-management");
        }, 3000);
        // await getUserManagement()
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "err",
          summary: `${err?.res?.data?.message}`,
        });
      });
  };

  const approveUserHandler = async (id) => {
    setIsLoading(true);
    getApprove(id, { approve: true }, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(() => {
          navigate("/user-management");
        }, 3000);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const onEditHandler = async (id) => {
    navigate(`/user-management/editUser?userId=${id}`);
  };

  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {show && (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="logout-modal"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-title text-center">
            Are you sure you want to delete this user?
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center">
            <Button
              variant="secondary"
              className="me-3 yes-btn-cls-add"
              onClick={() => {
                deleteUser(id);
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="no-btn-cls-add"
              onClick={() => {
                setShow(false);
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="less-all-side">
        <div className="userprofile-pics">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <Link to="/user-management">
                <svg
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
              </Link>
              <h6 className="mb-0">
                {serviceData?.first_name + "  " + serviceData?.last_name}
              </h6>
            </div>
            <div className="right-side-btn-add">
              {serviceData && !serviceData?.isApprove && (
                <button
                  className="btn btn-primary edit-btn-cls"
                  style={{ marginRight: "1rem" }}
                  // to="/user-management"
                  onClick={() => approveUserHandler(id)}
                >
                  {/* <button type="button" className="btn btn-primary edit-btn-cls"> */}
                  Approve
                </button>
              )}
              <button
                className="btn btn-primary edit-btn-cls"
                onClick={() => onEditHandler(id)}
                // to={{
                //   pathname: "/user-management/editUser",
                //   search: `?userId=${id}`,
                // }}
              >
                Edit
              </button>
            </div>
          </div>
        </div>

        <div className="body-part-area-start-profile">
          <label className="profile-tick">Profile</label>
          <div className="row mt-4">
            <div className="col-lg-3">
              <div className="first-sideuser">
                <img
                  src={
                    serviceData?.profile_pic
                      ? serviceData?.profile_pic
                      : require("../../assets/defaultImg.png")
                  }
                  alt="profile1"
                />
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>First Name</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">{serviceData?.first_name}</h6>
                    </div>
                  </div>
                </div>
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Email</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">{serviceData?.email}</h6>
                    </div>
                  </div>
                </div>
                {serviceData && (
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Voice Type</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {getVoiceType(serviceData?.voice_types)}
                        </h6>
                      </div>
                    </div>
                  </div>
                )}
                {/* <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Hall-Of-Fame</label>
                    <div className="subtitle-names">
                    <h6 className="mb-0">
                      {serviceData?.hall_of_fame ? "Yes" : "No"}
                      </h6>
                      </div>
                      </div>
                </div> */}
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Last Name</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">{serviceData?.last_name}</h6>
                    </div>
                  </div>
                </div>
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Country/ City</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {serviceData?.country + " , " + serviceData?.city}
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Age Ranges</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {serviceData?.min_age + " - " + serviceData?.max_age}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Gender</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {serviceData?.gender === "1"
                          ? "male"
                          : serviceData?.gender === "2"
                          ? "female"
                          : serviceData?.gender === "3"
                          ? "non-binary"
                          : "-"}
                      </h6>
                    </div>
                  </div>
                </div>
                {serviceData && (
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Languages</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {getVoiceLanguages(serviceData?.voice_languages)}
                        </h6>
                      </div>
                    </div>
                  </div>
                )}
                {serviceData && (
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Years of Experience</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {serviceData?.experience
                            ? serviceData.experience
                            : "-"}
                        </h6>
                      </div>
                    </div>
                  </div>
                )}
                {/* <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Super-Looper</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                      {serviceData?.super_looper ? "Yes": "No"}
                      </h6>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <hr />

          <div className="socials">
            <label className="social-text">Socials</label>
            <div className="row mt-4">
              <div className="col-lg-3 col-6">
                <div className="second-sideuser">
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Facebook</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {serviceData?.facebook ? serviceData?.facebook : "-"}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-6">
                <div className="second-sideuser">
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Instagram</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {serviceData?.instagram
                            ? serviceData?.instagram
                            : "-"}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-6">
                <div className="second-sideuser">
                  <div className="first-portion mb-3">
                    <div className="title-name">
                      <label>Website</label>
                      <div className="subtitle-names">
                        <h6 className="mb-0">
                          {serviceData?.website ? serviceData?.website : "-"}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />

          {serviceData?.agent && (
            <div className="socials">
              <label className="social-text">Agent Details</label>
              <div className="row mt-4">
                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Agent Name</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.agents.length > 0
                              ? serviceData?.agents[0].name
                              : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Agency Name</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.agents.length > 0
                              ? serviceData?.agents[0].agency_name
                              : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Telephone</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.agents.length > 0
                              ? serviceData?.agents[0].telephone
                              : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Email</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.agents.length > 0
                              ? serviceData?.agents[0].email
                              : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-0">
                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Website</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.agents.length > 0
                              ? serviceData?.agents[0].website
                              : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Address</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.agents.length > 0
                              ? serviceData?.agents[0].address
                              : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          )}
          {serviceData && (
            <div className="socials">
              <label className="social-text">Other Details</label>
              <div className="row mt-4">
                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Specialty</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {getSpecialties(serviceData?.specialties)}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Badge Status</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">{serviceData?.badges}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Union/ Nonunion?</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.union ? "Yes" : "No"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Home Studio?</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.home_studio ? "Yes" : "No"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-0">
                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Connectivity</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {getConnectivity(serviceData?.connectivities)}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Discoverable?</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                            {serviceData?.discoverable ? "Yes" : "No"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="second-sideuser">
                    <div className="first-portion mb-3">
                      <div className="title-name">
                        <label>Courtesy</label>
                        <div className="subtitle-names">
                          <h6 className="mb-0">
                           {serviceData?.courtesy ? serviceData?.courtesy : "-"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          )}
          <hr />

          <div className="right-sidebtn-add text-end">
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                onClick={() => {
                  navigate(-1);
                }}
                className="btn btn-primary outline-btn-cls me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary outline-btn-cls me-2"
                // onClick={() => deleteUser(id)}
                onClick={() => {
                  // setDeleteId(ele.id);
                  setShow(true);
                }}
              >
                Delete
              </button>
              <button type="button" className="btn btn-primary filled-btn-cls">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
